export default __webpack_public_path__ + "static/media/the_spicy.2f97b46d.JPG";